"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PDFPresentationThumbnail", {
  enumerable: true,
  get: function get() {
    return _PDFPresentationThumbnail["default"];
  }
});
var _PDFPresentationThumbnail = _interopRequireDefault(require("./PDFPresentationThumbnail"));